/**
 * Presence Zod Schemas
 *
 * Zod validation schemas for presence-related types.
 *
 * @module schemas/presence
 * @see SPEC-007 Requirements 4.1, 4.2, 4.3, 4.4, 4.5
 */
import { z } from 'zod';
import { MAX_DISPLAY_NAME_LENGTH, COLOR_ID_MIN, COLOR_ID_MAX } from '../types/presence';
/**
 * Position schema - cursor position in editor
 * @see Requirement 4.2
 */
export const PositionSchema = z.object({
    line: z.number().int().nonnegative(),
    column: z.number().int().nonnegative(),
});
/**
 * Selection schema - text selection range
 * @see Requirement 4.3
 */
export const SelectionSchema = z.object({
    anchor: PositionSchema,
    head: PositionSchema,
});
/**
 * Presence data schema
 * @see Requirements 4.1, 4.2, 4.3, 4.4, 4.5
 */
export const PresenceDataSchema = z.object({
    cursor: PositionSchema.nullable(),
    selection: SelectionSchema.nullable(),
    displayName: z.string().max(MAX_DISPLAY_NAME_LENGTH),
    colorId: z.number().int().min(COLOR_ID_MIN).max(COLOR_ID_MAX),
    updatedAt: z.number().int().positive(),
});
/**
 * Room participant schema
 * @see Requirements 4.6, 4.7
 */
export const RoomParticipantSchema = z.object({
    userId: z.string().min(1),
    presence: PresenceDataSchema,
    joinedAt: z.number().int().positive(),
});
/**
 * Partial presence data schema for updates
 */
export const PartialPresenceDataSchema = PresenceDataSchema.partial();
//# sourceMappingURL=presence.zod.js.map